export const callCenterVars = {
  order: 'order',
  tabIndexSelectedBrand: 'tabIndexSelectedBrand',
  selectedBrand: 'selectedBrand',
  discountOptions: 'discountOptions',
  configOrderHoldTime: 'configOrderHoldTime',
  showedModalAdditionalProducts: 'showedModalAdditionalProducts',
  productInEditing: 'productInEditing',
  showWarningModal: 'showWarningModal',
  prevTypeDiscount: 'prevTypeDiscount',
  objectWarningModal: 'objectWarningModal',
  prevSumDiscount: 'prevSumDiscount',
  blockChangeSumOfDiscount: 'blockChangeSumOfDiscount',
  orderProds: 'orderProds',
  promocodes: 'promocodes',
  usePromocodeSum: 'usePromocodeSum',
  activatedPromocodeGood: 'activatedPromocodeGood',
  promocodeGoodValue: 'promocodeGoodValue',
  productsBrandOriginMap: 'productsBrandOriginMap',
  promocodeBrand: 'promocodeBrand',
  mapProducts: 'mapProducts',
  mapAdditionalGoods: 'mapAdditionalGoods',
  configOrdersCount: 'configOrdersCount',
  motivatedMinRequiredSumOfProducts: 'motivatedMinRequiredSumOfProducts',
  lastId: 'lastId',
  courierAutoAssign: 'courierAutoAssign',
  isRestManager: 'isRestManager'
}

export const orderWorkshopVars = {
  statsOrdersDetailed: 'statsOrdersDetailed',
  detailsStatsInterval: 'detailsStatsInterval',
  loadingOverallStatsWorkshop: 'loadingOverallStatsWorkshop'
}

export const motivateAccountingVars = {
  listWorkersOnWork: 'listWorkersOnWork'
}

export const overallWorkshopStatsVars = {
  workersOnWork: 'workersOnWork',
  statsWorkers: 'statsWorkers',
  minHour: 'minHour',
  motivatePercents: 'motivatePercents',
  totalTurnover: 'totalTurnover',
  totalEarnMotivate: 'totalEarnMotivate',
  requestedDay: 'requestedDay'
}

export const workshopsVars = {
  WORKSHOPS: 'WORKSHOPS'
}

export const motivateMonitorWorkshopVars = {
  cookingTargetCurrentStats: 'cookingTargetCurrentStats'
}


// WEBPACK FOOTER //
// ./src/constants/vuexVariables.js